module.exports = __webpack_public_path__ + "img/landing-mob.76e2e89a.jpg";